import { createFileRoute } from '@tanstack/react-router'
import { useSpaceViewPageSetup } from '../hooks/useSpaceViewPageSetup'
import { TaskPageLayout } from '@/routes/features/tasks/components/TaskPageLayout'
import { StatusGroupedTaskView } from '@/routes/features/tasks/components/StatusGroupedTaskView'
import { ProjectViewControls } from '@/routes/features/projects/components/ProjectViewControls'
import { FilterBar } from '@/components/features/filters'
import { Loading } from '@/components/app/indicators/Loading'
import useProjectViewPreferencesStore from '@/store/ProjectViewPreferencesStore'

export const Route = createFileRoute(
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/list',
)({
  component: SpaceListViewPage,
})

function SpaceListViewPage() {
  const { workspaceSlug, spaceKey } = Route.useParams()
  const { space, spaceLoading, listTasks, isLoading } =
    useSpaceViewPageSetup(workspaceSlug, spaceKey, (spaceId) => (
      <ProjectViewControls
        projectId={spaceId}
        scope="space"
        pinnedFields={['project']}
      />
    ))
  const detailsPanel = useProjectViewPreferencesStore(
    (s) => s.preferences[space?.id ?? '']?.detailsPanel ?? 'on',
  )
  const listGroupBy = useProjectViewPreferencesStore(
    (s) => s.preferences[space?.id ?? '']?.listGroupBy ?? 'status',
  )

  if (spaceLoading) {
    return (
      <div className="flex min-h-full flex-1 items-center justify-center">
        <Loading />
      </div>
    )
  }

  if (!space) return null

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex-shrink-0">
        <FilterBar projectId={space.id} pinnedFields={['project']} scope="space" />
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        <TaskPageLayout
          tasks={listTasks}
          isLoading={isLoading}
          renderTaskView={listGroupBy === 'status' ? StatusGroupedTaskView : undefined}
          navigateToSubtasks={true}
          showViewModeToggle={false}
          showAddTaskInput={false}
          viewModeOverride={detailsPanel === 'on' ? 'split' : 'simple'}
        />
      </div>
    </div>
  )
}
